import io from "socket.io-client";
import store from "../store";
import auth from "../api/auth";
import notification from "../components/subcomponents/notification";

let fw_update_timeout = {};

let socket_device;

function startSocket() {
  if (socket_device) {
    console.log("connection to namespace: default already exists.");
    connect();
  } else {
    connect();
    console.log("connect to namespace: default");
  }
  socket_device.on("device_pulse", function (data) {
    store.dispatch({
      type: "DEVICE_PULSE",
      server_time: data.server_time,
      event_action: data.action,
      data: data.data,
    });
  });

  socket_device.on("device_event", function (data) {
    store.dispatch({
      type: "DEVICE_EVENT",
      server_time: data.server_time,
      event_action: data.action,
      data: data.data,
    });
  });

  socket_device.on("alarm_event", function (data) {
    store.dispatch({
      type: "ALARM_EVENT",
      server_time: data.server_time,
      event_action: data.action,
      data: data.data,
    });
  });

  socket_device.on("first_event", function (data) {
    store.dispatch({
      type: "DEVICE_EVENT",
      server_time: data.server_time,
      event_action: data.action,
      data: data.data,
    });
  });

  socket_device.on("server_error", function (data) {
    notification.error(data);
  });

  socket_device.on("server_notice", function (data) {
    notification.info(data);
  });
  socket_device.on("server_success", function (data) {
    notification.success(data);
  });

  socket_device.on("component_event", function (data) {
    store.dispatch({
      type: data.action,
      server_time: data.server_time,
      data: data.modules,
    });
  });

  socket_device.on("mqtt_message", function (data) {
    store.dispatch({
      type: "MQTT_MESSAGE",
      data: data,
    });
  });
  socket_device.on("race_details", function (data) {
    store.dispatch({
      type: "RACE_DETAILS",
      data: data,
    });
  });
  socket_device.on("race_event", function (data) {
    store.dispatch({
      type: "RACE_EVENT",
      data: data,
    });
  });
  socket_device.on("race_event_competitor", function (data) {
    store.dispatch({
      type: "RACE_EVENT_COMPETITOR",
      data: data,
    });
  });
}
function connect() {
  const state = store.getState();
  socket_device = io.connect(
    (state.systemR.connection.host.includes("localhost")
      ? "http://"
      : "https://") + state.systemR.connection.host
  );
  socket_device.on("connect", () => {
    console.log("connecting");
    socket_device
      .emit("authenticate", { token: state.authR.token.token_key }) //send the jwt
      .on("authenticated", () => {
        console.info("socket.io authenticated");
      })
      .on("unauthorized", (msg) => {
        console.log(`unauthorized: ${JSON.stringify(msg.data)}`);
        console.log("refresh token");
        auth.login_silent(() => {});
      });
  });
}

function disconnect() {
  if (socket_device) {
    console.log("delete connection on default namespace");
    socket_device.disconnect();
  }
}

export default {
  startSocket: startSocket,
  disconnect: disconnect,
  fw_update_timeout: fw_update_timeout,
};
